<template>
    <b-card no-body>
        <b-tabs pills active-nav-item-class="nav-pill-success" nav-class="bg-light p-50 custom-nav mx-50 mt-50 mb-0" lazy>
            <b-tab title="KYKM">
                <advance-payment-group-key-kykm/>
            </b-tab>
            <b-tab title="Maaş">
                <advance-payment-group-key-r-salary/>
            </b-tab>
            <b-tab title="İcra">
                <advance-payment-group-key-levy/>
            </b-tab>
            <b-tab title="BES">
                <advance-payment-group-key-bes/>
            </b-tab>
        </b-tabs>
    </b-card>
</template>

<script>
import { BTab, BTabs, BCard } from 'bootstrap-vue'
import AdvancePaymentGroupKeyKYKM from './AdvancePaymentGroupKeyKYKM.vue'
import AdvancePaymentGroupKeyRSalary from './AdvancePaymentGroupKeyRSalary.vue'
import AdvancePaymentGroupKeyLevy from './AdvancePaymentGroupKeyLevy.vue'
import AdvancePaymentGroupKeyBes from './AdvancePaymentGroupKeyBes.vue'

export default {
    components:{
        BTab,
        BTabs,
        BCard,
        'advance-payment-group-key-kykm':AdvancePaymentGroupKeyKYKM,
        'advance-payment-group-key-r-salary':AdvancePaymentGroupKeyRSalary,
        'advance-payment-group-key-levy':AdvancePaymentGroupKeyLevy,
        'advance-payment-group-key-bes':AdvancePaymentGroupKeyBes
    }
}
</script>